import { update_menu } from '../modules/menu';
import { sliders } from '../modules/sliders';
import { active_section } from '../modules/waypoints';
// import { rerun_gravity_forms_scripts } from '../modules/forms';
import { setupLightbox } from '../modules/page';

export default {
	init() {
		// JavaScript to be fired on all pages
		update_menu();
		setup_scrolling();
		setup_back_to_top();
		sliders();
		active_section();
		// rerun_gravity_forms_scripts();
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};

/**
 * Sets up the scrolled class
 */
function setup_scrolling()
{
	$(window).on('scroll', function() {
		//Add the 'scrolled' class
		let scroll = $(this).scrollTop();
		let body = $('body');
		if(scroll > 0)
		{
			body.addClass('scrolled');
		}
		else
		{
			body.removeClass('scrolled');
		}
	});
}

/**
 * Sets up a scroll to top on any back to top classes
 */
function setup_back_to_top()
{
	$('.back-to-top').click(function (e){
		e.preventDefault();
		$('html,body').animate({
			scrollTop: 0,
		}, 'slow');
	});
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js